import { apiRequest } from './client';

// Per-parent notification settings. Only `weeklyRecap` currently drives
// anything server-side (the Sunday recap sweep); the rest are stored so the
// Notifications tab round-trips honestly. See NOTIFICATION_ROWS in the web
// Notifications tab for which are live.
export type NotificationPrefs = {
  weeklyRecap: boolean;
  stickerUnlocked: boolean;
  watchRequests: boolean;
  bedtimeReminders: boolean;
  billing: boolean;
  productNews: boolean;
};

export const notificationsApi = {
  get: (token: string) =>
    apiRequest<NotificationPrefs>('/v1/notifications/prefs', { token }),

  // Send only the toggle that changed; the backend upserts.
  update: (patch: Partial<NotificationPrefs>, token: string) =>
    apiRequest<NotificationPrefs>('/v1/notifications/prefs', {
      method: 'PUT',
      body: patch,
      token,
    }),
};
